import type { PayloadAction } from "@reduxjs/toolkit"
import { createSlice } from "@reduxjs/toolkit"

import type { LeaderboardRecord } from "@/api/pointsApi"
import { logoutAction } from "@/store/session/logoutAction"
import type { RootState } from "@/store/store"

interface LeaderboardState {
  records: LeaderboardRecord[]
  refCode: string | null
  loaded: boolean
}

const initialState: LeaderboardState = {
  records: [],
  refCode: null,
  loaded: false,
}

const leaderboardSlice = createSlice({
  name: "leaderboard",
  initialState,
  reducers: {
    setLeaderboard: (
      state,
      action: PayloadAction<{
        records: LeaderboardRecord[]
        refCode: string | null
      }>,
    ) => {
      state.records = action.payload.records
      state.refCode = action.payload.refCode
      state.loaded = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => initialState)
  },
})

export const { setLeaderboard } = leaderboardSlice.actions

export const selectLeaderboardRecords = (state: RootState) =>
  state.leaderboard.records
export const selectLeaderboardRefCode = (state: RootState) =>
  state.leaderboard.refCode
export const selectLeaderboardLoaded = (state: RootState) =>
  state.leaderboard.loaded

export default leaderboardSlice.reducer
